<template>
  <div class="padding-zero">
    <div v-if="notFoundEmployeesOrders">
      <table-header
        :title="'Zamówienia, dla których seniorzy nie znaleźli opiekuna'"
        :withPagination="true"
        :dispatchAction="'fetchOrdersWithoutEmployee'"
        :onPage="this.ordersWithoutEmployee.on_page"
        :pageNumber="this.ordersWithoutEmployee.page_number"
        :total="this.ordersWithoutEmployee.total"
        :refreshAction="true"
        :tableName="'notFoundOrders'"
        :toggleOption="true"
        :toggleValue="true"
        @handleToggle="handleLists(false)"
        :downloadAction="true"
        :withoutSearchInput="true"
      ></table-header>

      <table class="table table-stripper">
        <thead>
          <tr class="tr-table">
            <th scope="col">ID</th>
            <th scope="col">Data wyszukiwania</th>
            <th scope="col">Dni zamówienia</th>
            <th scope="col">Użytkownik szukający pomocy</th>
            <th scope="col">Telefon uzytkownika szukającego pomocy</th>
            <th scope="col">Usługa</th>
            <th scope="col">Kod pocztowy</th>
            <th scope="col">Miasto</th>
            <th scope="col">Ulica</th>
            <th scope="col">Latitude</th>
            <th scope="col">Longitude</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in ordersWithoutEmployee.orders.filter(
              (item) => item.service
            )"
            :key="item.id"
          >
            <td>{{ item.id }}</td>
            <td>{{ formattedDate(item.creationDate) }}</td>
            <td v-if="item.order_days">
              <!-- more than 1 -->
              <button
                v-if="item.order_days && item.order_days.split(',').length > 1"
                type="button"
                data-toggle="modal"
                :data-target="`#orderDaysWithoutEmployee${item.id}`"
                class="btn btn-sm btn-outline-dark"
              >
                Dni zamówienia
              </button>

              <!-- 1 day -->
              <p
                v-if="
                  item.order_days && item.order_days.split(',').length === 1
                "
              >
                {{ formattedDateWithoutTime(item.order_days) }}
              </p>
              <p
                v-if="
                  !item.order_days || item.order_days.split(',').length === 0
                "
              >
                Brak
              </p>
            </td>
            <td v-else>
              {{ formattedDateWithoutTime(item.creation_date) }}
            </td>
            <td>{{ item.profile.first_name }} {{ item.profile.last_name }}</td>
            <td>{{ formatPhoneNumber(item.user.phone) }}</td>
            <td v-if="item.service">
              {{ item.service.display_name }} -
              {{ item.service.description }}
            </td>
            <td>{{ item.postcode }}</td>
            <td>{{ item.city }}</td>
            <td>{{ item.street }}</td>
            <td>{{ item.lat }}</td>
            <td>{{ item.lng }}</td>
            <!-- Order days -->
            <div
              v-if="item.order_days"
              class="modal fade"
              :id="`orderDaysWithoutEmployee${item.id}`"
              tabindex="-1"
              role="dialog"
              aria-labelledby="orderDaysWithoutEmployee"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Dni w jakich senior chciał zamówić usługę
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                      @click="closeOrderDaysModal"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body messagesBody">
                    <table class="table">
                      <thead>
                        <tr class="tr-table">
                          <th style="text-align: center !important" scope="col">
                            Data
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="day in item.order_days.split(',')"
                          :key="day"
                        >
                          <td style="text-align: center !important">
                            {{ formattedDateWithoutTime(day) }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </tr>
        </tbody>
      </table>
    </div>
    <div v-else>
      <table-header
        :filters="filteringOptions"
        :title="' Historia usług'"
        :withPagination="true"
        :withFilters="true"
        :dispatchAction="'getOrdersWithStatus'"
        :onPage="this.orders.orders.on_page"
        :pageNumber="this.orders.orders.page_number"
        :total="this.orders.orders.total"
        :refreshAction="true"
        :tableName="'ordersHistory'"
        :dates="true"
        :dateFields="dateFieldOptions"
        :toggleOption="true"
        :toggleValue="false"
        @handleToggle="handleLists(true)"
        :downloadAction="true"
        :emitRefresh="refreshCounter"
      ></table-header>

      <table class="table table-sm table-stripped">
        <thead>
          <tr class="tr-table">
            <th>
              <div class="d-flex align-items-center" style="gap: 10px">
                <button
                  v-if="orders && orders.orders && orders.orders.list"
                  class="btn btn-sm btn-outline-dark withoutHover"
                  @click="selectAllAcceptedOrders"
                >
                  Zaznacz wszystkie
                </button>
                <button
                  v-if="selectedOrdersIds.length > 0"
                  class="btn btn-sm btn-outline-dark withoutHover"
                  data-toggle="modal"
                  data-target="#changeMultipleOrdersStatusModal"
                >
                  Zmień status
                </button>
              </div>
            </th>
            <th></th>
            <th scope="col">ID zamówienia</th>
            <th scope="col">Ponów zamówienie</th>
            <th scope="col">Zamówiona usługa</th>
            <th scope="col">Dla kogo</th>
            <th scope="col">Potrzebujący</th>
            <th scope="col">Telefon Potrzebującego</th>
            <th scope="col">Data utworzenia</th>
            <th scope="col">Termin Wykonania</th>
            <th scope="col">Zamawiający</th>
            <th scope="col">Telefon Zamawiającego</th>
            <th scope="col">Opiekun</th>
            <th scope="col">Telefon Opiekuna</th>
            <th scope="col">Faktura</th>
            <th scope="col">Cena</th>
            <th scope="col">Kod promocyjny</th>
            <th scope="col">Cena po zniżce</th>
            <th scope="col">Dni zamówienia</th>
            <th scope="col">Status zamówienia</th>
            <th scope="col">Lista rejected</th>
            <th scope="col">Wiadomości</th>
            <th scope="col">Więcej</th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="item in orders.orders.list"
            :key="item.id"
            :class="item.main_order_id ? 'rejected-order-background' : ''"
          >
            <td>
              <input
                type="checkbox"
                :disabled="item.order_state !== 'ACCEPTED'"
                v-model="item.selected"
                @change="updateSelectedOrderIds(item)"
                class="order-checkbox"
              />
            </td>
            <td>
              <div :style="item.rejected_order ? '' : 'visibility: hidden'">
                <i
                  v-if="!showedRejectedOrdersIds.includes(item.id)"
                  class="fa fa-arrow-circle-down arrow-icon"
                  aria-hidden="true"
                  @click="showRejectedOrder(item.id)"
                ></i>
                <i
                  v-else
                  class="fa fa-arrow-circle-up arrow-icon"
                  aria-hidden="true"
                  @click="hideRejectedOrder(item.id)"
                ></i>
              </div>
            </td>

            <td>
              <div class="id-column">
                <img
                  @click="copyText(item.id)"
                  style="cursor: pointer"
                  src="@/icons/copy-icons.svg"
                  alt=""
                />
              </div>
            </td>
            <td>
              <button
                v-if="
                  !item.service_category_type ||
                  item.service_category_type === 'NONE'
                "
                type="button"
                data-toggle="modal"
                data-target="#repeatOrderModal"
                class="btn btn-sm btn-outline-dark"
                @click="prepareOrderToRepeat(item)"
              >
                Ponów
              </button>
              <p v-else>Brak możliwości ponowienia zamówienia</p>
            </td>

            <td class="service-name-container">
              <div class="text-center">
                <img
                  data-toggle="modal"
                  :data-target="`#orderedService${item.id}`"
                  style="cursor: pointer"
                  src="@/icons/more-info.svg"
                  alt=""
                  width="20px"
                />
              </div>
              <p class="text-center">
                {{ item.service_category_name }},

                <span
                  v-if="
                    item.service_name === item.service_category_name &&
                    item.service_description &&
                    item.service_description.length < 100
                  "
                  >{{ item.service_description }}</span
                >
                <span v-else>
                  {{ item.service_name }}
                </span>
              </p>
            </td>
            <td>{{ item.for_myself }}</td>
            <td>
              {{
                (item.for_myself === "Dla siebie" && item.crs_user_id) ||
                item.for_myself === "Dla kogoś"
                  ? item.crs_first_name
                  : "Użytkownik nieaktywny"
              }}
              {{ item.crs_user_id ? item.crs_last_name : "" }}
            </td>
            <td>
              {{
                (item.for_myself === "Dla siebie" && item.crs_user_id) ||
                item.for_myself === "Dla kogoś"
                  ? formatPhoneNumber(item.crs_phone)
                  : "Brak"
              }}
            </td>
            <td>{{ formattedDate(item.creation_date) }}</td>
            <td>{{ formattedDate(item.date_To) }}</td>

            <td>
              {{ item.ordered_user_first_name }}
              {{
                item.ordered_user_last_name !== "Użytkownik nieaktywny"
                  ? item.ordered_user_last_name
                  : ""
              }}
            </td>
            <td>{{ formatPhoneNumber(item.ordered_user_phone) }}</td>

            <td>
              {{ item.employee_first_name }}
              {{
                item.employee_last_name !== "Użytkownik nieaktywny"
                  ? item.employee_last_name
                  : ""
              }}
            </td>
            <td>{{ formatPhoneNumber(item.employee_phone) }}</td>

            <td>
              <div
                v-if="
                  item.has_invoice_public_url &&
                  Number(item.has_invoice_public_url) === 1
                "
              >
                <div class="flex">
                  <img
                    @click="fetchInvoiceLink(item.id)"
                    style="cursor: pointer"
                    src="@/icons/download.svg"
                    alt=""
                  />
                  <img
                    @click="copyInvoiceLinkToClipboard(item.id)"
                    style="cursor: pointer; margin-left: 5px"
                    src="@/icons/copy-icons.svg"
                    alt=""
                  />
                </div>

                <a
                  :href="invoiceLink"
                  :id="`downloadLink${item.id}`"
                  style="visibility: hidden"
                ></a>
              </div>
              <div v-else>Brak</div>
            </td>
            <td>
              {{
                item.rejected_order &&
                item.rejected_order.rejected_order &&
                item.basic_price >=
                  item.rejected_order.rejected_order.basic_price
                  ? item.rejected_order.rejected_order.basic_price
                  : item.basic_price
              }}
            </td>

            <td>
              {{ item.promotional_code || "Brak" }}
            </td>

            <td>
              {{ item.price_after_discount || "Brak zniżki" }}
            </td>
            <td>
              <button
                @click="openOrderDaysModal(item)"
                type="button"
                class="btn btn-sm btn-outline-dark"
              >
                {{
                  parseOrderDays(item.order_days) &&
                  parseOrderDays(item.order_days).length === 1
                    ? formattedDateWithoutTime(
                        parseOrderDays(item.order_days)[0].date
                      )
                    : "Podgląd dni zamówienia"
                }}
              </button>
              <p
                v-if="
                  !parseOrderDays(item.order_days) ||
                  parseOrderDays(item.order_days).length === 0
                "
              >
                Brak
              </p>
            </td>
            <td>
              <div class="orderStatusWithRejectMessage">
                <div class="statusBlock">
                  <button
                    v-if="['ACCEPTED', 'WAITING'].includes(item.order_state)"
                    type="button"
                    data-toggle="modal"
                    :data-target="`#changeOrderStatusModal${item.id}`"
                    class="btn btn-sm btn-outline-dark"
                    @click="
                      setSelectedStatusToChangeByCurrentOrderState(
                        item.order_state
                      )
                    "
                  >
                    {{
                      item.order_state === "REJECTED" &&
                      item.automatically_finished === "Tak"
                        ? "REJECTED_AUTOMATICALLY"
                        : item.order_state
                    }}
                  </button>
                  <p v-else>{{ item.order_state }}</p>

                  <div></div>
                  <div v-if="item.unrealized_status">
                    <p
                      class="unrealized_info_waiting"
                      v-if="item.unrealized_status === 'UNREALIZED_WAITING'"
                    >
                      Oczekujące na decyzję
                    </p>
                    <p
                      class="unrealized_info_customer"
                      v-if="item.unrealized_status === 'UNREALIZED_CUSTOMER'"
                    >
                      Niezrealizowane z winy seniora
                    </p>
                    <p
                      class="unrealized_info_employee"
                      v-if="item.unrealized_status === 'UNREALIZED_EMPLOYEE'"
                    >
                      Niezrealizowane z winy opiekuna
                    </p>
                    <p
                      class="unrealized_info_employee"
                      v-if="item.unrealized_status === 'CANCELLED'"
                    >
                      Zlecenie anulowane bez opłat serwisowych
                    </p>
                  </div>
                </div>
                <div class="statusButtons">
                  <button
                    v-if="
                      item.employee_refusal_message &&
                      item.employee_refusal_message.trim().length > 0 &&
                      item.employee_refusal_message !== 'Cancelled' &&
                      item.order_state !== 'FINISHED'
                    "
                    type="button"
                    data-toggle="modal"
                    :data-target="`#refusalEmployee${item.id}`"
                    class="btn btn-sm btn-outline-dark"
                  >
                    Powód opiekuna
                  </button>
                  <button
                    v-if="
                      item.customer_refusal_message &&
                      item.customer_refusal_message.trim().length > 0 &&
                      item.customer_refusal_message !== 'Cancelled' &&
                      item.order_state !== 'FINISHED'
                    "
                    type="button"
                    data-toggle="modal"
                    :data-target="`#refusalCustomer${item.id}`"
                    class="btn btn-sm btn-outline-dark"
                  >
                    Powód seniora
                  </button>
                  <button
                    v-if="
                      item.unrealized_status &&
                      item.unrealized_status === 'UNREALIZED_WAITING' &&
                      item.order_state !== 'FINISHED'
                    "
                    type="button"
                    data-toggle="modal"
                    :data-target="`#decision${item.id}`"
                    class="btn btn-sm btn-outline-dark"
                  >
                    Decyzja
                  </button>
                </div>
              </div>
            </td>
            <td>
              <button
                v-if="item.temporary_order_id"
                type="button"
                data-toggle="modal"
                :data-target="`#temporaryOrderEmployees${item.id}`"
                class="btn btn-sm btn-outline-dark"
                @click="
                  setTemporaryOrderEmployeesToShow(item.temporary_order_id)
                "
              >
                Lista
              </button>
              <p v-else>Brak</p>
            </td>
            <td>
              <button
                @click="getMessages(item.id, item.ordered_user_id)"
                type="button"
                data-toggle="modal"
                data-target="#messages"
                class="btn btn-sm btn-outline-dark"
              >
                Wiadomości
              </button>
            </td>
            <td>
              <button
                type="button"
                data-toggle="modal"
                :data-target="`#moreInfo${item.id}`"
                class="btn btn-sm btn-outline-gradient"
              >
                Więcej
              </button>
            </td>

            <!-- Messages modal -->
            <div
              class="modal fade messagesModal"
              id="messages"
              tabindex="-1"
              role="dialog"
              aria-labelledby="messages"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Wiadomości między użytkownikami
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div v-if="messagesLoading" class="modal-body messagesBody">
                    Ładowanie wiadomości...
                  </div>

                  <div
                    v-else-if="messages && messages.length > 0"
                    class="modal-body messagesBody"
                  >
                    <div
                      class="messages-wrapper"
                      id="messages-container"
                      ref="messages-container"
                      v-show="messages != null && messages.length > 0"
                    >
                      <div
                        v-for="message in messages"
                        :key="message.id"
                        class="messageBlock"
                        :style="
                          message.user_id === seniorIdToMessages
                            ? 'border-bottom-left-radius: 0;  align-self: flex-start;'
                            : 'border-bottom-right-radius: 0;align-self: flex-end;'
                        "
                      >
                        <div
                          class="messageInBlock"
                          :style="
                            message.type !== 'IMAGE'
                              ? message.user_id === seniorIdToMessages
                                ? 'background: #EC1A6B;border-bottom-left-radius: 0;justify-content: flex-start;'
                                : 'background:#090741;border-bottom-right-radius: 0;justify-content: flex-end;'
                              : message.user_id === seniorIdToMessages
                              ? 'background: white;border-bottom-left-radius: 0;justify-content: flex-start;'
                              : 'background:white;border-bottom-right-radius: 0;justify-content: flex-end;'
                          "
                        >
                          <!-- AVATARS -->
                          <div
                            v-if="
                              !message.from_first_name &&
                              seniorIdToMessages === message.user_id
                            "
                            class="messageAuthorUser"
                          >
                            <img
                              class="img-avatar"
                              :src="
                                getUrl() +
                                `/api/profile/photo/${message.file_id}`
                              "
                              style="margin-right: 5px"
                            />
                          </div>
                          <div v-else class="messageAuthorAdmin">
                            <img
                              class="img-avatar"
                              :src="
                                getUrl() +
                                `/api/profile/photo/${message.file_id}`
                              "
                              style="margin-right: 5px"
                            />
                          </div>

                          <!-- MESSAGE DATE -->
                          <div
                            class="messageBlockDateUser"
                            v-if="
                              !message.from_first_name &&
                              seniorIdToMessages === message.user_id
                            "
                          >
                            {{ formattedDateToString(message.creation_date) }}
                          </div>
                          <div v-else class="messageBlockDateAdmin">
                            {{ formattedDateToString(message.creation_date) }}
                          </div>
                          <span
                            v-if="
                              !message.from_first_name &&
                              seniorIdToMessages === message.user_id
                            "
                            class="userFirstName"
                            >Senior</span
                          >
                          <span v-else class="adminFirstName">Opiekun</span>
                          <span v-if="message.type === 'TEXT'">
                            {{ message.message }}
                          </span>
                          <span v-if="message.type === 'IMAGE'">
                            <a target="_blank" :href="message.message">
                              <img
                                :src="message.message"
                                class="imgInMessage"
                              />
                            </a>
                          </span>
                          <span v-if="message.type === 'ATTACHMENT'">
                            <span
                              class="attachmentText"
                              @click="getFile(message.message, message.id)"
                              >Załącznik do pobrania</span
                            ><i
                              class="fas fa-download attachmentDownloadButton"
                              @click="getFile(message.message, message.id)"
                            ></i>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div v-else class="modal-body messagesBody">
                    <div class="alert alert-danger notFoundListAlert">
                      Brak wiadomości
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Change order status modal -->
            <div
              class="modal fade"
              :id="`changeOrderStatusModal${item.id}`"
              tabindex="-1"
              role="dialog"
              aria-labelledby="moreInfo"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Zmiana statusu zamówienia
                    </h5>
                    <button
                      type="button"
                      class="close closeChangeOrderStatusModal"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body messagesBody">
                    <p><label>Status</label></p>
                    <select
                      v-if="item.order_state === 'ACCEPTED'"
                      v-model="selectedStatusToChange"
                      class="w-25"
                    >
                      <option value="UNREALIZED">UNREALIZED</option>
                      <option value="REJECTED">REJECTED</option>
                      <option value="FINISHED">FINISHED</option>
                    </select>
                    <select
                      v-if="item.order_state === 'WAITING'"
                      v-model="selectedStatusToChange"
                      class="w-25"
                    >
                      <option value="REJECTED">REJECTED</option>
                      <option value="ACCEPTED">ACCEPTED</option>
                    </select>
                    <div class="change-status-buttons w-50 m-auto">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-light w-25"
                        data-dismiss="modal"
                      >
                        Anuluj
                      </button>
                      <button
                        :disabled="changeStatusButtonDisabled"
                        type="button"
                        class="btn btn-sm btn-outline-dark w-25"
                        @click="changeOrderStatus(item.id)"
                      >
                        Zapisz
                      </button>
                    </div>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                      id="closeChangeOrderStatusModal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Multiple orders status change modal -->
            <div
              class="modal fade"
              id="changeMultipleOrdersStatusModal"
              tabindex="-1"
              role="dialog"
              aria-labelledby="changeMultipleOrdersStatusModal"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title">Zmiana statusu wielu zamówień</h5>
                    <button
                      type="button"
                      class="close closeChangeMultipleOrdersStatusModal"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body messagesBody">
                    <p>
                      Wybrano {{ selectedOrdersIds.length }} zamówień do zmiany
                      statusu.
                    </p>
                    <p><label>Status</label></p>
                    <select v-model="selectedStatusToChange" class="w-25">
                      <option value="UNREALIZED">UNREALIZED</option>
                      <option value="REJECTED">REJECTED</option>
                      <option value="FINISHED">FINISHED</option>
                    </select>
                    <div class="change-status-buttons w-50 m-auto">
                      <button
                        type="button"
                        class="btn btn-sm btn-outline-light w-25"
                        data-dismiss="modal"
                      >
                        Anuluj
                      </button>
                      <button
                        :disabled="
                          changeStatusButtonDisabled || !selectedStatusToChange
                        "
                        type="button"
                        class="btn btn-sm btn-outline-dark w-25"
                        @click="changeOrderStatusForMultipleOrders"
                      >
                        Zapisz
                      </button>
                    </div>
                  </div>
                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                      id="closeChangeMultipleOrdersStatusModal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- More info modal -->
            <div
              class="modal fade"
              :id="`moreInfo${item.id}`"
              tabindex="-1"
              role="dialog"
              aria-labelledby="moreInfo"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Więcej informacji
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body messagesBody">
                    <table class="table">
                      <thead>
                        <tr class="tr-table">
                          <th scope="col">E-Mail</th>
                          <th scope="col">Miejscowość</th>
                          <th scope="col">Ulica</th>
                          <th scope="col">Numer domu</th>
                          <th scope="col">Numer lokalu</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ item.crs_email || "Brak" }}</td>
                          <td>{{ item.city || "Brak" }}</td>
                          <td>{{ item.street || "Brak" }}</td>
                          <td>{{ item.number1 || "Brak" }}</td>
                          <td>{{ item.number2 || "Brak" }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Order days -->
            <order-days-modal
              :order="selectedOrderForOrderDays"
              @orderDayChanged="handleRefreshList"
            />

            <!-- Temporary order employees -->
            <div
              :ref="`temporaryOrderEmployees${item.id}`"
              class="modal fade temporaryOrderModal"
              :id="`temporaryOrderEmployees${item.id}`"
              tabindex="-1"
              role="dialog"
              aria-labelledby="orderDays"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Powiadomienia do opiekunów
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body messagesBody">
                    <table class="table">
                      <thead>
                        <tr class="tr-table">
                          <th scope="col">Id użytkownika</th>
                          <th scope="col">Imię użytkownika</th>
                          <th scope="col">Nazwisko użytkownika</th>
                          <th scope="col">Nr tel. użytkownika</th>
                          <th scope="col">Status</th>
                          <th scope="col">Czy został wybrany przez Seniora?</th>
                          <th scope="col">Szczegóły</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          v-for="temporaryOrderEmployee in temporaryOrderEmployees"
                          :key="temporaryOrderEmployee.id"
                        >
                          <td>{{ temporaryOrderEmployee.userId }}</td>
                          <td>{{ temporaryOrderEmployee.firstname }}</td>
                          <td>{{ temporaryOrderEmployee.lastname }}</td>
                          <td>
                            {{
                              formatPhoneNumber(temporaryOrderEmployee.phone)
                            }}
                          </td>
                          <td>
                            {{
                              translateTemporaryOrderEmployeeStatus(
                                temporaryOrderEmployee.status
                              )
                            }}
                          </td>
                          <td>
                            {{
                              temporaryOrderEmployee.selectedBySenior
                                ? "Tak"
                                : "Nie"
                            }}
                          </td>
                          <td>
                            <router-link
                              :to="{
                                path:
                                  'users/id/' + temporaryOrderEmployee.userId,
                              }"
                            >
                              <button
                                type="button"
                                class="btn btn-outline-dark mr-3"
                                data-dismiss="modal"
                              >
                                Przejdź
                              </button>
                            </router-link>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Service -->
            <div
              class="modal fade"
              :id="`orderedService${item.id}`"
              tabindex="-1"
              role="dialog"
              aria-labelledby="services"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Zamówiona usługa
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body messagesBody">
                    <table class="table">
                      <thead>
                        <tr class="tr-table">
                          <th scope="col">ID usługi</th>
                          <th scope="col">Kategoria</th>
                          <th scope="col">Podkategoria</th>
                          <th scope="col">Usługa</th>
                          <th scope="col">Opis uslugi</th>
                          <th scope="col">Cena</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>{{ item.service_id }}</td>
                          <td v-if="item.service_category_name">
                            {{ item.service_category_name }}
                          </td>
                          <td v-if="item.service_id">
                            {{
                              item.subcategory_name
                                ? item.subcategory_name
                                : "Brak"
                            }}
                          </td>

                          <td v-if="item.service_id">
                            {{ item.service_name }}
                          </td>
                          <td
                            v-if="item.service_id"
                            v-html="item.service_description"
                          ></td>
                          <td v-if="item.service_id">
                            {{ item.service_price }}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Refusal EMPLOYEE -->
            <div
              class="modal fade"
              :id="`refusalEmployee${item.id}`"
              tabindex="-1"
              role="dialog"
              aria-labelledby="refusalEmployee"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Powód niezrealizowania usługi (Opiekun)
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body messagesBody">
                    <h4>{{ item.employee_refusal_comment }}</h4>
                    <h6>{{ item.employee_refusal_message }}</h6>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Refusal SENIOR -->
            <div
              class="modal fade"
              :id="`refusalCustomer${item.id}`"
              tabindex="-1"
              role="dialog"
              aria-labelledby="refusalCustomer"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="exampleModalLabel">
                      Powód niezrealizowania usługi (Senior)
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body messagesBody">
                    <h4>{{ item.customer_refusal_comment }}</h4>
                    <h6>{{ item.customer_refusal_message }}</h6>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark"
                      data-dismiss="modal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <!-- Decision -->
            <div
              class="modal fade"
              :id="`decision${item.id}`"
              tabindex="-1"
              role="dialog"
              aria-labelledby="decision"
              aria-hidden="true"
            >
              <div
                class="modal-dialog modal-xl modal-dialog modal-xl-scrollable"
                role="document"
              >
                <div class="modal-content">
                  <div class="modal-header">
                    <h5 class="modal-title" id="decision">
                      Podejmij decyzję w sporze między stronami zamówienia
                    </h5>
                    <button
                      type="button"
                      class="close"
                      data-dismiss="modal"
                      aria-label="Close"
                    >
                      <span aria-hidden="true">&times;</span>
                    </button>
                  </div>
                  <div class="modal-body messagesBody">
                    <h6>{{ item.customer_refusal_comment }}</h6>
                    <h6>{{ item.customer_refusal_message }}</h6>

                    <form
                      @submit.prevent="handleUnrealizedDecision(item.id)"
                      class="unrealizedOrdersDecisionForm"
                    >
                      Decyzja w sprawie sporu:
                      <select v-model="unrealized_decision">
                        <option value="" disabled selected>Decyzja...</option>
                        <option value="FINISHED">
                          Zlecenie zostało wykonane prawidłowo
                        </option>
                        <option value="UNREALIZED_EMPLOYEE">
                          Zlecenie nie zostało zrealizowane z winy opiekuna
                        </option>
                        <option value="UNREALIZED_CUSTOMER">
                          Zlecenie nie zostało zrealizowane z winy seniora
                        </option>
                        <option value="CANCELLED">
                          Anuluj zlecenie bez opłat serwisowych
                        </option>
                        <option value="CANCELLED_WITHOUT_MONEY_RETURN">
                          Anuluj zlecenie bez zwrotu środków
                        </option>
                      </select>
                      <button
                        class="btn btn-outline-dark btn-sm"
                        type="submit"
                        :disabled="sendingDecision === true"
                      >
                        Zapisz
                      </button>
                    </form>
                  </div>

                  <div class="modal-footer">
                    <button
                      type="button"
                      class="btn btn-outline-dark closeDecisionModalButton"
                      data-dismiss="modal"
                    >
                      Zamknij
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </tr>
        </tbody>
      </table>

      <!-- Repeat order modal -->
      <repeat-order-modal
        modalName="repeatOrderModal"
        :order="selectedOrderToRepeat"
        :userPromotionalCodes="userPromotionalCodes"
        @orderRepeated="handleOrderRepeated"
      />
    </div>
  </div>
</template>

<script>
import { URL } from "../axios";
import axios from "../axios";
import TableHeader from "../components/TableHeader";
import shared from "../shared";
import { pl } from "vuejs-datepicker/dist/locale";
import OrderDaysModal from "../components/OrderDaysModal.vue";
import RepeatOrderModal from "../components/RepeatOrderModal.vue";

export default {
  name: "services-history",
  components: {
    TableHeader,
    OrderDaysModal,
    RepeatOrderModal,
  },
  computed: {
    orders() {
      try {
        const ordersObject = this.$store.getters.getOrdersWithStatus;
        if (ordersObject) {
          let ordersList = ordersObject.orders.list;
          let rejectedOrders =
            ordersObject.orders.orders_from_which_new_one_was_created;
          if (ordersList) {
            ordersList.map((o) => {
              // Initialize selected property for checkboxes
              o.selected = this.selectedOrdersIds.includes(o.id) || false;
              const orderDaysResponse = [];
              const orderDaysString = o.order_days;
              if (typeof orderDaysString === "string") {
                const splittedOrderDays = orderDaysString.split(",");
                splittedOrderDays.forEach((sod) => {
                  const splittedFields = sod.split(";");
                  const id = splittedFields[0];
                  const date = splittedFields[1];
                  const status = splittedFields[2];
                  orderDaysResponse.push({
                    id,
                    date,
                    status,
                  });
                });

                o.order_days = orderDaysResponse;
                o.rejected_order = rejectedOrders
                  ? rejectedOrders.find((ro) => ro.created_order_id === o.id)
                  : null;
              }
            });

            this.showedRejectedOrdersIds.forEach((orderId) => {
              const rejectedOrderObject = rejectedOrders
                ? rejectedOrders.find((o) => o.created_order_id === orderId)
                : null;
              const rejectedOrderToAdd = rejectedOrderObject
                ? rejectedOrderObject.rejected_order
                : null;

              const addedOrderIds = ordersList.map((o) => o.id);
              if (
                rejectedOrderToAdd &&
                !addedOrderIds.includes(rejectedOrderToAdd.id)
              ) {
                const orderIndexInMainList = ordersList.findIndex(
                  (o) => o.id === orderId
                );

                rejectedOrderToAdd.main_order_id =
                  ordersList[orderIndexInMainList].id;

                ordersList.insert(orderIndexInMainList + 1, rejectedOrderToAdd);
              }
            });

            ordersList = ordersList.filter(
              (o) => !this.hiddenRejectedOrdersIds.includes(o.main_order_id)
            );
            ordersObject.orders.list = ordersList;

            return ordersObject;
          } else {
            return ordersObject;
          }
        } else {
          return ordersObject;
        }
      } catch (error) {
        return this.$store.getters.getOrdersWithStatus;
      }
    },
    ordersWithoutEmployee() {
      return this.$store.getters.getOrdersWithoutEmployee;
    },
  },
  created() {
    Array.prototype.insert = function (index, ...items) {
      this.splice(index, 0, ...items);
    };

    this.fetchData();
    this.formattedDate = shared.formattedDate;
    this.startOfDay = shared.startOfDayFromTimestampDate;
    this.endOfDay = shared.endOfDayFromTimestampDate;
    this.formattedDateWithoutTime = shared.formattedDateWithoutTime;
    this.formatPhoneNumber = shared.formatPhoneNumber;
    this.dateWithoutTimeToString = shared.dateWithoutTimeToString;
    this.formattedDateToString = shared.formattedDateToString;
  },
  data() {
    return {
      selectedOrdersIds: [],
      notFoundEmployeesOrders: false,
      status: "FINISHED",
      date_from: "",
      date_to: "",
      sendingDecision: false,
      // Pole daty, po którym działa filtr zakresu - REALIZATION to kolumna "Termin wykonania".
      dateFieldOptions: [
        {
          name: "CREATION",
          displayName: "Data utworzenia",
        },
        {
          name: "REALIZATION",
          displayName: "Data realizacji",
        },
      ],
      filteringOptions: [
        {
          name: "",
          displayName: "ALL",
        },
        {
          name: "FINISHED",
          displayName: "FINISHED",
        },
        {
          name: "REJECTED",
          displayName: "REJECTED",
        },
        {
          name: "REJECTED_AUTOMATICALLY",
          displayName: "REJECTED_AUTOMATICALLY",
        },
        {
          name: "ACCEPTED",
          displayName: "ACCEPTED",
        },
        {
          name: "WAITING",
          displayName: "WAITING",
        },
        {
          name: "INITIALIZED",
          displayName: "INITIALIZED",
        },
        {
          name: "UNREALIZED",
          displayName: "UNREALIZED",
        },
        {
          name: "UNREALIZED_WAITING",
          displayName: "UNREALIZED_WAITING",
        },
        {
          name: "UNREALIZED_EMPLOYEE",
          displayName: "UNREALIZED_EMPLOYEE",
        },
        {
          name: "UNREALIZED_CUSTOMER",
          displayName: "UNREALIZED_CUSTOMER",
        },
        {
          name: "CANCELLED_CUSTOMER",
          displayName: "CANCELLED_CUSTOMER",
        },
        {
          name: "CANCELLED_EMPLOYEE",
          displayName: "CANCELLED_EMPLOYEE",
        },
        {
          name: "FINISHED_IN_LESS_THAN_AN_HOUR",
          displayName: "FINISHED_IN_LESS_THAN_AN_HOUR",
        },
      ],
      invoiceLink: "",
      unrealized_decision: "",
      orderDayDatePickerVisible: false,
      selectedOrderDayToChange: "",
      newOrderDay: "",
      pl: pl,
      temporaryOrderEmployees: [],
      showedRejectedOrdersIds: [],
      hiddenRejectedOrdersIds: [],
      selectedStatusToChange: "",
      seniorIdToMessages: null,
      messages: null,
      messagesLoading: false,
      selectedOrderForOrderDays: null,
      refreshCounter: 1,
      changeStatusButtonDisabled: false,
      userPromotionalCodes: [],
      selectedOrderToRepeat: null,
    };
  },
  mounted() {
    let input = window.document.querySelector(".tableSearchBlock");
    if (this.$router.currentRoute.query.search) {
      input.focus();
      setTimeout(() => {
        var evt = new CustomEvent("keypress");
        evt.which = 13;
        evt.keyCode = 13;
        input.dispatchEvent(evt);
      }, 400);
    }
  },
  methods: {
    updateSelectedOrderIds(item) {
      if (item.selected) {
        if (!this.selectedOrdersIds.includes(item.id)) {
          this.selectedOrdersIds.push(item.id);
        }
      } else {
        this.selectedOrdersIds = this.selectedOrdersIds.filter(
          (id) => id !== item.id
        );
      }
    },
    selectAllAcceptedOrders() {
      if (!this.orders || !this.orders.orders || !this.orders.orders.list)
        return;

      const acceptedOrders = this.orders.orders.list.filter(
        (item) => item.order_state === "ACCEPTED"
      );

      // Check if all are already selected
      const allSelected = acceptedOrders.every((item) => item.selected);

      // Toggle selection
      acceptedOrders.forEach((item) => {
        item.selected = !allSelected;
        this.updateSelectedOrderIds(item);
      });
    },
    async prepareOrderToRepeat(order) {
      this.selectedOrderToRepeat = order;
      const userId = order.ordered_user_id;

      await axios
        .get(
          `/api/userPromotionalCode?promotional=true&active=true&userId=${userId}`
        )
        .then((response) => {
          this.userPromotionalCodes = response.data;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async handleOrderRepeated() {
      this.handleRefreshList();
      this.fetchData();
    },

    handleRefreshList() {
      this.refreshCounter += 1;
    },
    openOrderDaysModal(order) {
      this.selectedOrderForOrderDays = order;
      const btnToOpen = window.document.getElementById("orderDaysModal-open");
      if (btnToOpen) btnToOpen.click();
    },
    parseOrderDays(orderDays) {
      const daysArray = [];
      if (typeof orderDays !== "string") {
        return orderDays;
      }

      const orders = orderDays.split(",");

      for (const order of orders) {
        const [orderId, dateTime, status] = order.split(";");

        daysArray.push({
          date: dateTime,
          id: orderId,
          status: status,
        });
      }
      return daysArray;
    },
    getUrl() {
      return URL;
    },

    async getMessages(id, seniorIdToMessages) {
      try {
        this.messages = null;
        this.messagesLoading = true;
        const url = `api/chat/messages/order/${id}`;
        this.seniorIdToMessages = seniorIdToMessages;
        const response = await axios.get(url);
        this.messages = response.data.reverse();
      } catch (error) {
        console.log(error);
      } finally {
        this.messagesLoading = false;
      }
    },

    async changeOrderStatusForMultipleOrders() {
      if (!this.selectedOrdersIds.length || !this.selectedStatusToChange)
        return;

      try {
        this.changeStatusButtonDisabled = true;

        const response = await axios.put(`/api/admin/orders/bulkEdit`, {
          order_state: this.selectedStatusToChange,
          orders_ids: this.selectedOrdersIds,
        });

        if (response && response.status === 200) {
          document
            .querySelector("#closeChangeMultipleOrdersStatusModal")
            .click();

          this.selectedOrdersIds = [];

          setTimeout(() => {
            this.handleRefreshList();
          }, 1000);
        } else {
          this.$notify({
            group: "error",
            text: "Wystąpił błąd podczas zmiany statusu. Spróbuj ponownie",
          });
        }
      } catch (error) {
        console.log(error);
        this.$notify({
          group: "error",
          text: "Wystąpił błąd podczas zmiany statusu. Spróbuj ponownie",
        });
      } finally {
        this.changeStatusButtonDisabled = false;
      }
    },

    async changeOrderStatus(orderId) {
      try {
        this.changeStatusButtonDisabled = true;
        const response = await axios.put(`/api/admin/orders/${orderId}`, {
          order_state: this.selectedStatusToChange,
        });
        if (response && response.status === 200) {
          document.querySelector("#closeChangeOrderStatusModal").click();
          this.changeStatusButtonDisabled = false;
          this.$notify({
            group: "success",
            text: "Status zamówienia został zmieniony pomyślnie",
          });

          setTimeout(() => {
            this.handleRefreshList();
          }, 1000);
        } else {
          this.$notify({
            group: "error",
            text: "Wystąpił błąd podczas zmiany statusu. Spróbuj ponownie",
          });
        }
      } catch (error) {
        console.log(error);
      } finally {
        this.changeStatusButtonDisabled = false;
      }
    },

    setSelectedStatusToChangeByCurrentOrderState(currentOrderState) {
      if (currentOrderState === "ACCEPTED") {
        this.selectedStatusToChange = "UNREALIZED";
      } else {
        this.selectedStatusToChange = "REJECTED";
      }
    },
    async setTemporaryOrderEmployeesToShow(temporaryOrderId) {
      this.temporaryOrderEmployees = [];
      const employees = await axios.get(
        `/api/temporaryOrder/${temporaryOrderId}/employees`
      );
      this.temporaryOrderEmployees = employees.data;
      // console.log(this.temporaryOrderEmployees);
    },
    async copyText(text) {
      const selBox = document.createElement("textarea");
      selBox.style.position = "fixed";
      selBox.style.left = "0";
      selBox.style.top = "0";
      selBox.style.opacity = "0";
      selBox.value = text;
      document.body.appendChild(selBox);
      selBox.focus();
      selBox.select();
      document.execCommand("copy");
      document.body.removeChild(selBox);
      this.$notify({
        group: "success",
        text: "ID zamówienia zostało skopiowane",
      });
    },

    async markAsUnrealized(order) {
      const refreshButton = document.querySelector(".refresh-list-icon");
      const response = confirm(
        "Czy na pewno oznaczyć zamówienia jako niezrealizowane?"
      );
      if (response) {
        await axios.put(`/api/order/${order.id}/unrealized`);
        if (refreshButton) {
          refreshButton.click();
        }
      }
    },
    closeOrderDaysModal() {
      this.orderDayDatePickerVisible = false;
      this.selectedOrderDayToChange = "";
      this.newOrderDay = "";
    },
    showDatePickerForOrderDay(day) {
      this.orderDayDatePickerVisible = true;
      this.selectedOrderDayToChange = day;
    },

    translateTemporaryOrderEmployeeStatus(status) {
      switch (status) {
        case "REJECTED":
          return "Odrzucił";
        case "ACCEPTED":
          return "Zaakceptował";
        case "WAITING":
          return "Nie podjął decyzji";
        default:
          return "Nie podjął decyzji";
      }
    },
    handleLists(list) {
      this.notFoundEmployeesOrders = list;
    },

    async copyInvoiceLinkToClipboard(id) {
      let link = "";
      await axios.get(`/api/payment/invoice/${id}`).then((response) => {
        link = response.data;
      });
      const el = document.createElement("textarea");
      el.value = link;
      el.setAttribute("readonly", "");
      el.style.position = "absolute";
      el.style.left = "-9999px";
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$notify({
        group: "success",
        text: "Link do faktury został skopiowany",
      });
    },

    async fetchInvoiceLink(id) {
      this.invoiceLink = null;
      await axios.get(`/api/payment/invoice/${id}`).then((response) => {
        this.invoiceLink = response.data;
      });

      document.getElementById(`downloadLink${id}`).click();
    },
    fetchData() {
      this.$store.dispatch("getOrdersWithStatus", {});
      this.$store.dispatch("fetchOrdersWithoutEmployee", {});
    },
    async handleUnrealizedDecision(orderId) {
      const url = `/api/order/changeStatusUnrealized/${orderId}?decision=${this.unrealized_decision}`;

      if (this.sendingDecision === false) {
        this.sendingDecision = true;
        await axios
          .post(url)
          .then((response) => {
            if (response.status === 200) {
              document.querySelector(".closeDecisionModalButton").click();
              const refreshButton =
                document.querySelector(".refresh-list-icon");
              if (refreshButton) {
                refreshButton.click();
              }
            }
            this.sendingDecision = false;
          })
          .catch((err) => {
            console.log(err);
            this.sendingDecision = false;
          });
      }
    },

    showRejectedOrder(orderId) {
      this.hiddenRejectedOrdersIds = this.hiddenRejectedOrdersIds.filter(
        (id) => id !== orderId
      );
      this.showedRejectedOrdersIds.push(orderId);
    },

    hideRejectedOrder(orderId) {
      this.showedRejectedOrdersIds = this.showedRejectedOrdersIds.filter(
        (id) => id !== orderId
      );
      this.hiddenRejectedOrdersIds.push(orderId);
    },
  },
};
</script>

<style scoped>
.order-checkbox {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.order-checkbox:disabled {
  cursor: not-allowed;
  opacity: 0.6;
}

.statusBlock,
.statusButtons {
  text-align: center;
}

.id-column {
  display: flex;
  align-items: center;
  gap: 20px;
}
.arrow-icon {
  cursor: pointer;
  font-size: 20px;
}
.rejected-order-background {
  background: rgba(227, 27, 27, 0.1);
}
.messageDate {
  position: absolute;
  top: 3px;
  right: 3px;
}
.messagesBody {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.messageBlock {
  position: relative;
  overflow-wrap: anywhere;
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;
  flex-direction: column;
  margin-left: 20px;
  flex-wrap: wrap;
  margin: 10px;
  border: 1px solid rgb(121, 118, 118);
  border-radius: 10px;
  width: 300px;
  width: fit-content;
}
.messageBlock img {
  border-radius: 50px;
  width: 35px;
  height: 35px;
}
.messages-wrapper {
  overflow: scroll;
}
.form-group {
  width: 100%;
  margin: 40px auto;
}
.messages-wrapper {
  overflow-y: scroll;
  height: 500px;
  scrollbar-color: grey white;
  scrollbar-width: thin;
  display: flex;
  flex-direction: column;
  align-items: center;
  color: white;
  margin: 0;
  padding: 0;
  width: 650px;
  justify-items: center;
  align-content: center;
}
.messageInBlock {
  display: flex;
  justify-content: center;
  width: auto;
  border-radius: 10px;
  position: relative;
  margin-left: 50px;
  margin-right: 50px;
  max-width: 350px;
  min-height: 50px;
  align-items: center;
  padding: 10px;
  min-width: 70px;
}
.messageAuthorUser img {
  border-radius: 50px;
  width: 45px !important;
  height: 45px !important;
}
.messageAuthorUser,
.messageAuthorAdmin {
  border-radius: 50px;
  width: 45px !important;
  height: 45px !important;
}
.messageBlock {
  font-family: "Poppins", sans-serif;
  position: relative;
  margin-top: 40px;
  border: 0;
  display: flex;
  position: relative;
}
.messageAuthorUser {
  position: absolute;
  left: -55px;
  bottom: 5px;
}
.messageAuthorAdmin {
  position: absolute;
  right: -46px;
  bottom: -10px;
}
.messageBlockDateUser {
  position: absolute;
  bottom: -24px;
  left: -20px;
  color: rgb(126, 124, 124);
  min-width: 150px;
}
.messageBlockDateAdmin {
  position: absolute;
  bottom: -24px;
  right: -20px;
  color: rgb(126, 124, 124);
  min-width: 150px;
}

.message-image {
  max-height: 100px !important;
  width: 100px !important;
  height: 100px !important;
  margin-bottom: 5px;
}
.imageMessage {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.taskMessageAttachment {
  border-radius: 50px;
}
.adminFirstName {
  position: absolute;
  top: -17px;
  color: #090741;
  right: 10px;
}
.userFirstName {
  position: absolute;
  top: -17px;
  color: #090741;
}
.messageAuthorUser {
  width: 100px;
  height: 100px;
  border-radius: 5px;
}
.attachmentDownloadButton {
  cursor: pointer;
  margin-left: 5px;
}
.attachmentText {
  cursor: pointer;
}
.sendMessageForm {
  width: 100%;
  margin-top: 50px;
  position: relative;
  display: flex;
}
.sendMessageForm input {
}
#YourMessage {
  width: 95%;
  border-radius: 20px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
  border: none;
  min-height: 150px;
  height: auto;
  background: #ebe6e6;
  outline: none;
  padding: 10px;
  padding-left: 10px;
  position: relative;
  text-align: center;
}
#file-input {
  visibility: hidden;
}
.messageInput {
  width: 100%;
  position: relative;
}
.selectFileInfo {
  position: absolute;
  right: 20px;
  bottom: -10px;
  font-size: 11px;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}
.selectFileInfo i {
  color: tomato;
  margin-left: 5px;
  cursor: pointer;
}
.selectFileInfo i:hover {
  color: red;
  margin-left: 5px;
}

/* SCROLL */
.messages-wrapper::-webkit-scrollbar {
  width: 8px;
}
.messages-wrapper::-webkit-scrollbar-track {
  background: #f1f1f1;
}
.messages-wrapper::-webkit-scrollbar-thumb {
  background: #888;
}
.messages-wrapper::-webkit-scrollbar-thumb:hover {
  background: #555;
}
.charsCounter {
  position: absolute;
  bottom: 15px;
  right: 25px;
  font-size: 9px;
}
.labelAttachment {
  display: unset;
}
a:hover {
  text-decoration: none;
}
.imgInMessage {
  width: 100px;
}
.withoutHover:hover {
  background: #343a40 !important;
}
</style>
